import React, { useContext, useState } from 'react'
import { Typography, Box, Menu, MenuItem, ListItemText } from "@mui/material";
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import AdsClickOutlinedIcon from '@mui/icons-material/AdsClickOutlined';
import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined';
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import ChatBubbleOutlineOutlinedIcon from '@mui/icons-material/ChatBubbleOutlineOutlined';
import { InfoOutlined } from "@mui/icons-material";
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import ArrowRight from '@mui/icons-material/ArrowRight';
import { ThemeContext } from '../../context/ThemeContext';
import TranslateIcon from '@mui/icons-material/Translate';
import { useTranslation } from 'react-i18next';
import ContactUs from '../contactUS/ContactUS';
import OneClickTrading from '../modal/OneClickTrading';
import CheckIcon from '@mui/icons-material/Check';
import { HiLink } from "react-icons/hi";
import PeopleAltTwoToneIcon from '@mui/icons-material/PeopleAltTwoTone';
import PolicyOutlinedIcon from '@mui/icons-material/PolicyOutlined';
import TextSnippetOutlinedIcon from '@mui/icons-material/TextSnippetOutlined';
import companyInfo from '../../companyInfo/companyInfo.json'
import CompanyInfoPage from './CompanyInfoPage';
import { useSelector } from 'react-redux';

export default function UserMenu({ anchorEl, darkMode, id, client, handleClose, handleLogout, onOpenTradingAccounts,accountData }) {
  const [submenuAnchorEl, setSubmenuAnchorEl] = useState(null);
  const [hoverSubmenu, setHoverSubmenu] = useState(null);
  const { toggleTheme } = useContext(ThemeContext)
  const { i18n, t } = useTranslation();
  const [isContactUsOpen, setIsContactUsOpen] = useState(false);
  const [isDisclamerOpen, setIsDisclamerOpen] = useState(false);
  const [isCompanyDetailOpen, setIsCompanyDetailOpen] = useState(false);
  const [hasAcceptedDisclaimer, setHasAcceptedDisclaimer] = useState(false);  // Track if user accepted the disclaimer
  const companyData = companyInfo.find(info => info.id === 2);
  const userDetail = useSelector(state => state.user)

  const handleSubmenuOpen = (event, menu) => {
    setHoverSubmenu(menu);
    setSubmenuAnchorEl(event.currentTarget);
  };

  const handleSubmenuClose = () => {
    setHoverSubmenu(null);
    setSubmenuAnchorEl(null);
  };

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    localStorage.setItem('i18nextLng', lng);
    setSubmenuAnchorEl(null);
  };

  const handleOpenContactUs = () => {
    setIsContactUsOpen(true);
    handleClose(); // Close the user menu when opening the modal
  };

  const handleCloseContactUs = () => {
    setIsContactUsOpen(false);
  };
  const handleOpenDisclamer = () => {
    setIsDisclamerOpen(true);
    handleClose(); // Close the user menu when opening the modal
  };

  const handleCloseDisclamer = () => {
    setIsDisclamerOpen(false);
  };
  const handleAcceptDisclaimer = () => {
    setHasAcceptedDisclaimer(true); // Update state when user accepts
  };

  return (
    <>
      <Menu sx={{ "& .MuiList-root": { padding: 0 }, }} anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose} anchorOrigin={{ vertical: "bottom", horizontal: "right" }} transformOrigin={{ vertical: "top", horizontal: "right" }} PaperProps={{ elevation: 0, }} >
        <Box width={"250px"} p={1} key={id} data-summary={id} sx={{ backgroundColor: darkMode ? "#273649" : 'var(--white)', }}>
          {accountData?.demoAccount && <div className="ribbon"> {t('demo')}</div>}
          <ListItemText
            sx={{ pl: 2, }} primary={`${client.username || "Guest"}`} />

          <Typography sx={{ pl: 2, fontSize: 13, }} noWrap > {id || "N/A"}<i> - {process.env.REACT_APP_COMPANY_NAME} {accountData?.demoAccount && "- DEMO"}</i></Typography>
          <Box mt={2} sx={{ color: darkMode ? "var(--lightText)" : 'var(--darkText)' }}>
            {/* <MenuItem onMouseEnter={(e) => handleSubmenuOpen(e, "tradeSettings")} sx={{ fontSize: 13.5, marginBottom: '2px' }}><AccountCircleOutlinedIcon sx={{ fontSize: 20, marginRight: 1 }} />{t('title')} <ArrowRight sx={{ marginLeft: "auto", fontSize: '1.1rem' }} /></MenuItem>
            {hoverSubmenu === "tradeSettings" && (
              <Menu sx={{ "& .MuiList-root": { padding: 0 }, }} anchorEl={submenuAnchorEl} open={hoverSubmenu === "tradeSettings"} onClose={handleSubmenuClose} anchorOrigin={{ vertical: "top", horizontal: "right" }} MenuListProps={{ onMouseLeave: handleSubmenuClose, }}
                transformOrigin={{ vertical: "top", horizontal: "left" }} >
                <Box sx={{ backgroundColor: darkMode ? "#273649" : 'var(--white)' }} p={1} >
                  <MenuItem onClick={() => { handleClose(); onOpenTradingAccounts(); }} sx={{ color: darkMode ? "var(--lightText)" : 'var(--darkText)', fontSize: 13.5, }}><HiLink style={{ color: darkMode ? "var(--lightText)" : "var(--darkText)", fontSize: '1rem', marginRight: 5 }} />{t('connectToAccount')}</MenuItem>
                  <MenuItem onClick={() => { handleClose(); onOpenTradingAccounts(); }} sx={{ color: darkMode ? "var(--lightText)" : 'var(--darkText)', fontSize: 13.5, }}><PeopleAltTwoToneIcon style={{ color: "#2bbf53", fontSize: '1rem', marginRight: 5 }} />{t("openDemoAccount")}</MenuItem>
                  <MenuItem disabled sx={{ fontSize: 13.5, }}><PeopleAltTwoToneIcon style={{ color: "#ffcc00", fontSize: '1rem', marginRight: 5 }} />{t('openRealAccount')}</MenuItem>
                </Box>
              </Menu>
            )} */}

            <MenuItem onClick={handleOpenDisclamer} sx={{ fontSize: 13.5, marginBottom: '2px' }}>
              <AdsClickOutlinedIcon sx={{ fontSize: 20, marginRight: 1 }} />{t('oneClickTrading')}
              {hasAcceptedDisclaimer && <CheckIcon className='text-primary' sx={{ fontSize: 20, marginLeft: "auto" }} />}
            </MenuItem>
            <MenuItem onClick={toggleTheme} sx={{ fontSize: 13.5, marginBottom: '2px' }}>
              {darkMode ? (<><DarkModeOutlinedIcon sx={{ fontSize: 20, marginRight: 1 }} />{t('darkTheme')}</>) : (<><LightModeOutlinedIcon sx={{ fontSize: 20, marginRight: 1 }} />{t('lightTheme')}</>)}
            </MenuItem>
            <MenuItem onMouseEnter={(e) => handleSubmenuOpen(e, "languageSettings")} sx={{ fontSize: 13.5, marginBottom: '2px' }}> <TranslateIcon sx={{ fontSize: 20, marginRight: 1 }} />{t('language')}  <ArrowRight sx={{ marginLeft: "auto", fontSize: '1.1rem' }} /></MenuItem>
            {hoverSubmenu === "languageSettings" && (
              <Menu sx={{ "& .MuiList-root": { padding: 0 }, }} anchorEl={submenuAnchorEl} open={hoverSubmenu === "languageSettings"} onClose={handleSubmenuClose} anchorOrigin={{ vertical: "top", horizontal: "right" }} MenuListProps={{ onMouseLeave: handleSubmenuClose, }}
                transformOrigin={{ vertical: "top", horizontal: "left" }} >
                <Box sx={{ backgroundColor: darkMode ? "#273649" : 'var(--white)' }} p={1} >
                  <MenuItem sx={{ fontSize: 13.5, color: darkMode ? "var(--lightText)" : 'var(--darkText)' }} onClick={() => changeLanguage('en')}>{t('english')}</MenuItem>
                  <MenuItem sx={{ fontSize: 13.5, color: darkMode ? "var(--lightText)" : 'var(--darkText)' }} onClick={() => changeLanguage('ar')}>{t('arabic')}</MenuItem>
                  <MenuItem sx={{ fontSize: 13.5, color: darkMode ? "var(--lightText)" : 'var(--darkText)' }} onClick={() => changeLanguage('hi')}>{t('hindi')}</MenuItem>
                </Box>
              </Menu>
            )}

            <MenuItem sx={{ fontSize: 13.5, marginBottom: '2px' }} onClick={() => window.open(companyData?.helpPageUrl, '_blank')}><HelpOutlineOutlinedIcon sx={{ fontSize: 20, marginRight: 1 }} />{t("help")}</MenuItem>
            <MenuItem sx={{ fontSize: 13.5, marginBottom: '2px' }} onClick={() => window.open(companyData?.privacyPolicyUrl, '_blank')}><PolicyOutlinedIcon sx={{ fontSize: 20, marginRight: 1 }} />{t("privacyPolicy")}</MenuItem>
            <MenuItem sx={{ fontSize: 13.5, marginBottom: '2px' }} onClick={() => window.open(companyData?.termsOfServiceUrl, '_blank')} ><TextSnippetOutlinedIcon sx={{ fontSize: 20, marginRight: 1 }} />{t("termcondition")}</MenuItem>
            <MenuItem sx={{ fontSize: 13.5, marginBottom: '2px' }} onClick={handleOpenContactUs}><ChatBubbleOutlineOutlinedIcon sx={{ fontSize: 20, marginRight: 1 }} />{t('contactUs')}</MenuItem>
            <MenuItem sx={{ fontSize: 13.5, marginBottom: '2px' }} onClick={() => setIsCompanyDetailOpen(true)}><InfoOutlined sx={{ fontSize: 20, marginRight: 1 }} />{t('about')}</MenuItem>
            <MenuItem sx={{ fontSize: 13.5, marginBottom: '2px' }} onClick={handleLogout}><LogoutOutlinedIcon sx={{ fontSize: 20, marginRight: 1 }} />{t('logout')}</MenuItem>
          </Box>
        </Box>
      </Menu>
      {isContactUsOpen && <ContactUs isOpen={isContactUsOpen} onClose={handleCloseContactUs} />}
      {isDisclamerOpen && <OneClickTrading isOpen={isDisclamerOpen} onClose={handleCloseDisclamer} onAccept={handleAcceptDisclaimer} />}
      {isCompanyDetailOpen && <CompanyInfoPage companyData={companyData} isOpen={isCompanyDetailOpen} onClose={() => setIsCompanyDetailOpen(false)} />}
    </>)
}